import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { history, fetchWrapper } from "../_helpers";
import { getStoredValue } from "../_helpers/storagehelper";

// create slice

const name = "myContacts";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
// const extraReducers = createExtraReducers();
const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
  // extraReducers,
});

// exports

export const myContactsActions = { ...slice.actions, ...extraActions };
export const myContactsReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    error: null,
    PublicInmateConnectionResponse: [],
    CheckInmateConnectionStatus: null,
    InsertUpdateInmateStatus: null,
    LoadPublicMyContactsDisplayResponse: [],
    saveFundTransferResponse: [],
    user: getStoredValue("user"),
  };
}

function createReducers() {
  return {
    clearEmailResponse,
    clearInmateConnectionStatus,
    clearLoadPublicMyContactsDisplay,
    clearPublicMyContactsDisplayNew
  };
  function clearEmailResponse(state) {
    state.emailSaveResponse = [];
    state.PublicUserActivationEmailResponse = [];
    state.ActiveMailResponse = [];
    state.CheckInmateConnectionStatus = [];
    state.user = null;
  }

  function clearInmateConnectionStatus(state) {
    state.CheckInmateConnectionStatus = null; // Clear the specific state
    state.InsertUpdateInmateStatus = null;
    state.saveFundTransferResponse = null;
  }
  
  function clearLoadPublicMyContactsDisplay(state) {
    state.LoadPublicMyContactsDisplay = []; 
  }

  function clearPublicMyContactsDisplayNew(state) {
    state.PublicMyContactsDisplayNew = []; 
  }

}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/PublicUser/PurchaseCredits`;
  const commonBaseUrl = `${process.env.REACT_APP_API_URL}/Common`;
  const myContactsBaseUrl = `${process.env.REACT_APP_API_URL}/PublicUser/MyContacts`;

  const PublicUserUrl = `${process.env.REACT_APP_API_URL}/PublicUser/WriteMessage`;
  const FundTransferUrl = `${process.env.REACT_APP_API_URL}/PublicUser/MyContacts`;

  return {
    LoadPublicMyContactsDisplay: LoadPublicMyContactsDisplay(),
    LoadCreditDebitTransactionDetails: LoadCreditDebitTransactionDetails(),
    LoadPublicInmateConnectionDet: LoadPublicInmateConnectionDet(),
    UpdateInmateConnection: UpdateInmateConnection(),
    PublicMyContactsDisplayNew: PublicMyContactsDisplayNew(),
    saveFundTransfer: saveFundTransfer(),
    LoadPublicInmateByID: LoadPublicInmateByID(),
    PublicCreditBalance:PublicCreditBalance()
  };
  function LoadPublicMyContactsDisplay() {
    return createAsyncThunk(
      `${name}/LoadPublicMyContactsDisplay`,
      async ({
        userID,
        inmatesID,
        InmateLoadPurpose,
        ActiveStatus,
        SortField,
      }) =>
        await fetchWrapper.get(
          `${commonBaseUrl}/LoadPublicMyContactsDisplay?userID=${userID}&inmatesID=${inmatesID}&InmateLoadPurpose=${InmateLoadPurpose}&ActiveStatus=${ActiveStatus}&SortField=${SortField}`
        )
    );
  }

  function LoadPublicInmateByID() {
    return createAsyncThunk(
      `${name}/LoadPublicInmateByID`,
      async ({
        userID,
        inmatesID,
        InmateLoadPurpose,
        ActiveStatus,
        SortField,
      }) =>
        await fetchWrapper.get(
          `${commonBaseUrl}/LoadPublicMyContactsDisplay?userID=${userID}&inmatesID=${inmatesID}&InmateLoadPurpose=${InmateLoadPurpose}&ActiveStatus=${ActiveStatus}&SortField=${SortField}`
        )
    );
  }

  function PublicCreditBalance() {
    return createAsyncThunk(
      `${name}/PublicCreditBalance`,
      async ({
        userID,
        inmatesID
      }) =>
        await fetchWrapper.post(
          `${PublicUserUrl}/PublicCreditBalance?inmateId=${inmatesID}&userId=${userID}`
        )
    );
  }

  function LoadCreditDebitTransactionDetails() {
    return createAsyncThunk(
      `${name}/LoadCreditDebitTransactionDetails`,
      async (data) =>
        await fetchWrapper.post(
          `${baseUrl}/CreditDebitTransactionDetails`,
          data
        )
    );
  }

  // Before cancel myAccount this API will call - Check connection status
  function LoadPublicInmateConnectionDet() {
    return createAsyncThunk(
      `${name}/LoadPublicInmateConnectionDet`,
      async ({ userID,
        inmatesID }) =>
        await fetchWrapper.post(
          `${myContactsBaseUrl}/LoadPublicInmateConnectionDet?userID=${userID}&inmatesID=${inmatesID}`,
        )
    );
  }

  // Used for Cancel and Accept Inmate Account 
  function UpdateInmateConnection() {
    return createAsyncThunk(
      `${name}/UpdateInmateConnection`,
      async (data) =>
        await fetchWrapper.post(
          `${myContactsBaseUrl}/UpdateInmateConnection`,
          data
        )
    );
  }
  function PublicMyContactsDisplayNew() {
    return createAsyncThunk(
      `${name}/PublicMyContactsDisplayNew`,
      async ({
        userId,
        inmatesId,
        inmateLoadPurpose,
        activeStatus,
        sortField,
      }) =>
        await fetchWrapper.post(
          `${PublicUserUrl}/PublicMyContactsDisplayNew?userId=${userId}&inmatesId=${inmatesId}&inmateLoadPurpose=${inmateLoadPurpose}&activeStatus=${activeStatus}&sortField=${sortField}`
        )
    );
  }
  function saveFundTransfer() {
    return createAsyncThunk(
      `${name}/saveFundTransfer`,
      async (addFormData) =>
        await fetchWrapper.post(
          `${FundTransferUrl}/PublicUserFundTransfer`, addFormData)
      // async (addFormData) => await UserService.InsertUpdateUser(addFormData)
    );
  }
}

function createExtraReducers(builder) {
  builder
    // Handle resendActiveMail actions
    .addCase(extraActions.LoadPublicMyContactsDisplay.pending, (state) => {
      state.error = null;
    })
    .addCase(
      extraActions.LoadPublicMyContactsDisplay.fulfilled,
      (state, action) => {
        state.LoadPublicMyContactsDisplayResponse = [];
        state.LoadPublicMyContactsDisplay = action.payload;
        //const publicUser = getStoredValue("user");
      }
    )
    .addCase(
      extraActions.LoadPublicMyContactsDisplay.rejected,
      (state, action) => {
        state.error = action.error.message;
      }
    )
    //CreditDebitTransactionDetails
    .addCase(
      extraActions.LoadCreditDebitTransactionDetails.pending,
      (state) => {
        state.error = null;
      }
    )
    .addCase(
      extraActions.LoadCreditDebitTransactionDetails.fulfilled,
      (state, action) => {
        state.LoadCreditDebitTransactionDetails = action.payload;
        //const publicUser = getStoredValue("user");
      }
    )
    .addCase(
      extraActions.LoadCreditDebitTransactionDetails.rejected,
      (state, action) => {
        state.error = action.error.message;
      }
    )


    .addCase(extraActions.LoadPublicInmateConnectionDet.pending, (state) => {
      state.error = null;
    })
    .addCase(
      extraActions.LoadPublicInmateConnectionDet.fulfilled,
      (state, action) => {
        state.CheckInmateConnectionStatus = action.payload[0].ConnectionStatusID;
      }
    )
    .addCase(
      extraActions.LoadPublicInmateConnectionDet.rejected,
      (state, action) => {
        state.error = action.error.message;
      }
    )

    //  Used for Cancel and Accept Inmate Account 
    .addCase(extraActions.UpdateInmateConnection.pending, (state) => {
      state.error = null;
    })
    .addCase(
      extraActions.UpdateInmateConnection.fulfilled,
      (state, action) => {
        state.InsertUpdateInmateStatus = action.payload;
      }
    )
    .addCase(
      extraActions.UpdateInmateConnection.rejected,
      (state, action) => {
        state.error = action.error.message;
      }
    )

    //PublicMyContactsDisplayNew
    .addCase(extraActions.PublicMyContactsDisplayNew.pending, (state) => {
      state.error = null;
    })
    .addCase(
      extraActions.PublicMyContactsDisplayNew.fulfilled,
      (state, action) => {
        state.PublicMyContactsDisplayNew = action.payload;
      }
    )
    .addCase(
      extraActions.PublicMyContactsDisplayNew.rejected,
      (state, action) => {
        state.error = action.error.message;
      }
    )
    //saveFundTransfer
    .addCase(extraActions.saveFundTransfer.pending, (state) => {
      state.error = null;
    })
    .addCase(extraActions.saveFundTransfer.fulfilled, (state, action) => {
      state.saveFundTransferResponse = action.payload;
    })
    .addCase(extraActions.saveFundTransfer.rejected, (state, action) => {
      state.error = action.error.message;
    })


    // LoadPublicInmateByID actions
    .addCase(extraActions.LoadPublicInmateByID.pending, (state) => {
      state.error = null;
    })
    .addCase(
      extraActions.LoadPublicInmateByID.fulfilled,
      (state, action) => {
      }
    )
    .addCase(
      extraActions.LoadPublicInmateByID.rejected,
      (state, action) => {
        state.error = action.error.message;
      }
    )

     // Public user Credit Balance actions
     .addCase(extraActions.PublicCreditBalance.pending, (state) => {
      state.error = null;
    })
    .addCase(
      extraActions.PublicCreditBalance.fulfilled,
      (state, action) => {
      }
    )
    .addCase(
      extraActions.PublicCreditBalance.rejected,
      (state, action) => {
        state.error = action.error.message;
      }
    );



}
